export default class MattressQuiz {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions = () => {

        if (document.body.classList.contains('home') && document.cookie.indexOf('quiz_popup_closed=true') === -1) {
            // Show the popup if the cookie is not set
            $('.quiz-button').removeClass('hidden');

            $('[data-toggle="hamburger"]').click(() => {
                $('.quiz-button').toggleClass('hidden');
            });
        }

        // Close the popup and set the cookie
        $('.js-close-quiz-cta').click(() => {

            $('.quiz-button').addClass('hidden');

            // Calculate the expiration time in hours
            const hours = 24;

            // // Convert hours to milliseconds
            const expirationTime = hours * 60 * 60 * 1000;

            // Calculate the expiration date
            const expirationDate = new Date(Date.now() + expirationTime);

            // Convert the expiration date to UTC string
            const expirationDateString = expirationDate.toUTCString();

            // Set the cookie with the expiration time
            document.cookie = `quiz_popup_closed=true; expires=${expirationDateString}; path=/`;
        });

        function showResults() {

            let answers = [];

            $('.needhelp-modal.options-modal .options').each(function() {

                let answer = '';

                if ($(this).attr('data-question_key') != '') {
                    answer += $(this).attr('data-question_key') + ': ';
                }

                let resultKey = $(this).attr('data-result_key');

                let labels = [];
                let values = [];

                $(this).find('.item.active').each(function() {
                    labels.push($(this).attr('data-key'));

                    if ($(this).data('value') != '') {
                        values.push($(this).data('value'));
                    }

                });

                answers.push({
                    answer: answer += labels.join(','),
                    values: values,
                    resultKey: resultKey
                });

            });

            $('#answers-input').val(JSON.stringify(answers));
            $('#needhelp-form').submit();

        }

        function goNextQuizStep() {

            let $currentModalItem = $('.modal-item.active');

            if ($currentModalItem.find('.options .item.active').length == 0) return;

            if ($currentModalItem.attr('data-index') == $('#needhelp-step1').attr('data-steps-count')) {

                $(this).addClass('loading');
                showResults();

            } else {

                $currentModalItem.fadeOut(function() {

                    $currentModalItem.next().fadeIn();
                    $currentModalItem.removeClass('active');
                    $currentModalItem.next().addClass('active');

                });

            }

        }

        $('body').on('click', '#go-to-step-list', function() {

            if ($('#needhelp-step1').length) {

                $('#needhelp-contact').modal('hide');

                setTimeout(function() {
                    $('#needhelp-step1').modal('show');
                }, 500);

                return;

            }

            let cta = $(this);
            cta.addClass('loading');

            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: 'action=get_needhelp_modals',

                success: function(data) {
                    cta.removeClass('loading');
                    $('body').append(data);
                    $('#needhelp-contact').modal('hide');

                    setTimeout(function() {
                        $('#needhelp-step1').modal('show');
                    }, 500);

                },

                error: function(error) {
                    console.log(error);
                }
            });

        });

        let progress = 0;

        $('body').on('click', '.needhelp-modal.options-modal .options .item', function() {

            if ($(this).closest('.options').hasClass('multiple-values')) {

                $(this).toggleClass('active');

            } else {

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).closest('.options').find('.item').removeClass('active');
                    $(this).addClass('active');
                }

            }

            goNextQuizStep();

            //Grow progress bar
            const $progressBar = $('.js-needhelp-progress-bar');
            let stepsLength = $progressBar.data('steps-length');
            const stepProgress = 100/stepsLength;
            progress = progress + stepProgress;
            $('.js-needhelp-progress-bar .progress-bar-process').css('width', progress + '%');

        });

        $('body').on('click', '#needhelp-next', () => {

            let $currentModalItem = $('.modal-item.active');

            if ($currentModalItem.find('.options .item.active').length === 0) return;

            if ($currentModalItem.attr('data-index') === $('#needhelp-step1').attr('data-steps-count')) {

                $(this).addClass('loading');
                showResults();

            } else {

                $currentModalItem.fadeOut(() => {
                    $currentModalItem.next().fadeIn();
                    $currentModalItem.removeClass('active');
                    $currentModalItem.next().addClass('active');
                });

            }

        });

        $('body').on('click', '.needhelp-modal.options-modal .mutiple-values-label', () => {
            $(this).next().find('.item').addClass('active');
        });

        $(document).ready(() => {
            if (window.location.hash === '#quiz') {

                const modal = $('#quizModal');

                if (modal.length > 0) {
                    modal.click();
                }

            }
        });

    };
};

new MattressQuiz();